import React from "react";
import { render } from "react-dom";

import Interface from "./components/Interface";

export default props => {
  render(<Interface {...props} />, document.getElementById("site-nav"));
};
